<div class="row mb-1">
  <div class="col-md-12">
    Atividade
    <ng-select [disabled]="visualizar" id="selectAtividade" [(ngModel)]="atividadeSelecionada">
      <ng-option [value]="obj.controle" *ngFor="let obj of objPrincipal.atividades">{{ obj.descricao }}</ng-option>
    </ng-select>
  </div>
</div>
<div class="row mb-2">
  <div class="col-md-10">
    Selecionar Risco existente
    <ng-select [disabled]="visualizar" id="selectRisco" [(ngModel)]="riscoSelecionado" (change)="changeRisco()"
      [ngModelOptions]="{ standalone: true }">
      <ng-option *ngFor="let obj of listCriteriosRiscos" [value]="obj.id">
        {{ obj.nome }}
      </ng-option>
    </ng-select>
  </div>
  <div class="col-md-2">
    <br>
    <button *ngIf="!visualizar" type="button" class="btn btn-primary btn-sm" (click)="novoRisco()">
      <i class="fas fa-file"></i> Novo Risco
    </button>
  </div>
</div>
<div class="row mb-2">
  <div class="col-md-12">
    Nome do Risco
    <input type="text" [disabled]="habNovoRisco == false " id="txtCausa" class="form-control form-control-sm"
      [(ngModel)]="txtDescricaoRisco" />
  </div>
</div>
<div class="row mb-0">
  <div class="col-md-4">
    <br>
    <button *ngIf="!visualizar" type="button" class="btn btn-primary btn-sm" (click)="copiarRisco()">
      <i class="fas fa-copy"></i> Copiar Causas/Consequências
    </button>
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        Causas
        <div class="row mb-2">
          <div class="col-md-11">
            <textarea *ngIf="!visualizar" id="txtCausa" rows="2" 
              class="form-control form-control-sm" [(ngModel)]="txtCausa" maxlength="255">
            </textarea>
          </div>
          <div class="col-md-1">
            <button *ngIf="!visualizar" class="icon-btn btn btn-primary btn-xs text-left" (click)="addCausa()">
              <i class="far fas fa-plus fa-sm"></i>
            </button>
          </div>
        </div>
        <div class="row mb-1" *ngFor="let item of listCausa">
          <div class="col-md-11">
            <textarea [disabled]="visualizar" id="txtViewCausa" rows="2"
              class="form-control form-control-sm" 
              [(ngModel)]="item.descricao" maxlength="555">
            </textarea>
          </div>
          <div class="col-md-1">
            <button *ngIf="!visualizar" class="icon-btn btn btn-danger btn-xs text-left" (click)="removeCausa(item)">
              <i class="far fas fa-trash fa-sm"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        Consequências
        <div class="row mb-2">
          <div class="col-md-11">
            <textarea *ngIf="!visualizar" id="txtConsequencia" rows="2" 
              class="form-control form-control-sm" [(ngModel)]="txtConsequencia" maxlength="255">
            </textarea>
          </div>
          <div class="col-md-1">
            <button *ngIf="!visualizar" class="icon-btn btn btn-primary btn-xs text-left" (click)="addConsequencia()">
              <i class="far fas fa-plus fa-sm"></i>
            </button>
          </div>
        </div>
        <div class="row mb-1" *ngFor="let item of listConsequencia">
          <div class="col-md-11">
            <textarea [disabled]="visualizar" id="txtViewConsequencia" rows="2"
              class="form-control form-control-sm" 
              [(ngModel)]="item.descricao" maxlength="555">
            </textarea>
          </div>
          <div class="col-md-1">
            <button *ngIf="!visualizar" class="icon-btn btn btn-danger btn-xs text-left"
              (click)="removeConsequencia(item)">
              <i class="far fas fa-trash fa-sm"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-2">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-3" *ngFor="let escala of listEscalas">
            {{ escala.nome }}
            <ng-select [disabled]="visualizar" [id]='("select_" + escala.id)'
              [(ngModel)]="escala.idMagnitudeSelecionado" (change)="calculaRisco()">
              <ng-option [value]="magnitude.id" *ngFor="let magnitude of escala.listMagnitude">{{ magnitude.magnitude
                }}</ng-option>
            </ng-select>
          </div>

          <div class="col-md-3">
            Risco Inerente (RI)
            <input type="text" [disabled]="true" multiple="true" id="txtRiscoInerente"
              class="form-control form-control-sm" [(ngModel)]="txtRiscoInerente" maxlength="200" />
          </div>

          <div class="col-md-3">
            Nível de Risco Inerente
            <input type="text" [disabled]="true" multiple="true" id="txtNivelRiscoInerente"
              class="form-control form-control-sm" [(ngModel)]="txtNivelRiscoInerente" maxlength="200" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mb-2" *ngIf="!visualizar">
  <div class="col-md-8"></div>
  <div class="col-md-4" style="text-align: right;">
    <button type="button" class="btn btn-primary btn-sm" (click)="novo()">
      <i class="fas fa-file"></i> Novo
    </button>
    &nbsp;
    <button type="button" class="btn btn-success btn-sm" (click)="adicionar()">
      <i class="fas fa-plus"></i> {{ getNameBtn() }}
    </button>
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h4>Lista de Riscos Identificados</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-grid-abas-matriz-risco [dados]="objPrincipal.riscos" [listColunas]="listColunas"
          [visualizar]="this.visualizar" [siglaPosicao]="'R'" (btnRemover)="remover($event)"
          (btnEditar)="editar($event)"></app-grid-abas-matriz-risco>
      </div>
    </div>
  </div>
</div>